import React, { useState, useCallback } from "react";
import { PaginationData, Tutorial } from "../pagination/types";
import Videocard from "./Videocard";
import usePagination from "../pagination";
import { nanoid } from "nanoid";
import Container from "../Container";
import TutorialTab from "./TutorialTab";
import { getMyTutorials } from "./faketutorialdata";

const FavouriteTutorials = () => {
  const [data, setData] = useState<PaginationData<Tutorial>>();

  const callback = useCallback(
    ({ limit, offset }: { limit: number; offset: number }) => {
      const getData = async () => {
        const pageData = getMyTutorials<Tutorial>({
          limit,
          offset,
        });
        setData(pageData);
      };
      getData();
    },
    []
  );

  const { paginationComponent } = usePagination({
    key: nanoid(),
    total: data?.pagination.total,
    callback,
  });
  return (
    <Container>
      <TutorialTab />
      <>
        <div className="w-[100%] grid grid-cols-4 gap-5 mb-3 mt-3">
          {data?.data.map((tutorial, idx) => (
            <Videocard
              key={idx}
              id = {tutorial.id}
              price = {tutorial.price}
              videoLink={tutorial.videoLink}
              videoCardImage={tutorial.videoCardImage}
              tutor={tutorial.tutor}
              tutorialName={tutorial.tutorialName}
              tutorImage={tutorial.tutorImage}
            />
          ))}
        </div>
        {paginationComponent}
      </>
    </Container>
  );
};

export default FavouriteTutorials;
